import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view")
  const _component_chb_footer = _resolveComponent("chb-footer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          name: route.meta.transition || 'fade'
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_KeepAlive, { include: $data.includeComponents }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                key: route.path
              }))
            ], 1032, ["include"]))
          ]),
          _: 2
        }, 1032, ["name"])
      ]),
      _: 1
    }),
    (_ctx.$route.meta?.needFooter?true:false)
      ? (_openBlock(), _createBlock(_component_chb_footer, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
}